/* 🤖 this file was generated by svg-to-ts */
export const sbIconsBan: {
  name: 'ban';
  data: string;
} = {
  name: 'ban',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="M10 0A10 10 0 0 0 .7612 6.17316 10 10 0 0 0 2.92895 17.0711a9.9996 9.9996 0 0 0 5.12016 2.7367 9.999 9.999 0 0 0 5.7777-.569A9.9999 9.9999 0 0 0 20 10c0-1.31322-.2587-2.61358-.7612-3.82684a10.001 10.001 0 0 0-2.1677-3.24423A10 10 0 0 0 13.8268.7612 10 10 0 0 0 10 0m0 18c-2.12173 0-4.15656-.8429-5.65685-2.3432C2.84286 14.1566 2 12.1217 2 10a7.92 7.92 0 0 1 1.69-4.9L14.9 16.31A7.9198 7.9198 0 0 1 10 18m6.31-3.1L5.1 3.69A7.92 7.92 0 0 1 10 2c2.1217 0 4.1566.84285 5.6569 2.34314C17.1571 5.84344 18 7.87827 18 10a7.92 7.92 0 0 1-1.69 4.9"/></svg>`
};
